import React, { useCallback } from 'react';
import { Text } from '@adc/parallax-component-library';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Footer, Form, Input, Main, Spinner, TitleActionBar } from 'Components/utility';
import i18n from 'Utilities/i18n';
import * as log from 'Utilities/log';
const initialValues = { email: '' };
const ForgotPassFirstStep = ({ next, handleSubmitForgotPass, loading }) => {
    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .email(i18n.t('ForgotPassword.content.forgotPasswordForm.formField.email.errors.emailAddressValidEmail'))
            .required(i18n.t('ForgotPassword.content.forgotPasswordForm.formField.email.errors.required')),
    });
    const onSubmit = useCallback(async (values, { setSubmitting, submitForm }) => {
        setSubmitting(true);
        try {
            await handleSubmitForgotPass(values.email, submitForm);
            next(values);
        }
        catch (err) {
            log.error(err);
        }
        finally {
            setSubmitting(false);
        }
    }, [handleSubmitForgotPass, next]);
    const { handleSubmit, handleChange, handleBlur, isValid, isSubmitting, errors, touched, values } = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
        validateOnBlur: true,
    });
    return (React.createElement(Main, null,
        React.createElement(TitleActionBar, { testID: "ForgotPassword", title: i18n.t('ForgotPassword.title') }),
        loading && React.createElement(Spinner, null),
        React.createElement(Text, { testID: "ForgotPassword.title", textAlign: "auto", fontSize: "$bodyBase.default", fontWeight: "$bodyBase.default", color: "$text.100", padding: "$4" }, i18n.t('ForgotPassword.subtitle')),
        React.createElement(Form, null,
            React.createElement(Input, { "aria-label": i18n.t('ForgotPassword.content.forgotPasswordForm.formField.email.label'), placeholder: i18n.t('ForgotPassword.content.forgotPasswordForm.formField.email.placeholder'), label: i18n.t('ForgotPassword.content.forgotPasswordForm.formField.email.label'), errorMessage: errors.email, isInvalid: errors.email && touched.email ? true : false, testID: "email", value: values.email, marginTop: "$4", onChangeText: handleChange('email'), onBlur: handleBlur('email'), inputMode: "email" })),
        React.createElement(Footer, { buttonText: i18n.t('ForgotPassword.content.forgotPasswordForm.links.sendToEmail.label'), onButtonSubmit: handleSubmit, testIDButton: "ForgotPass.send-btn", isButtonDisabled: !values.email || !isValid || isSubmitting })));
};
export default ForgotPassFirstStep;
